export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '20a75c7', dateTime: 1780588449109 };